import { type ValueEvent } from '@adornis/base/utilTypes.js';
import '@adornis/chemistry/elements/components/x-button.js';
import '@adornis/chemistry/elements/components/x-flex.js';
import { XSnackbar } from '@adornis/chemistry/elements/components/x-snackbar.js';
import { XDialog } from '@adornis/dialog/x-dialog.js';
import { XInput } from '@adornis/forms/x-input.js';
import { emailRegexCheck } from '@adornis/users/db/validators.js';
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { ref } from 'lit/directives/ref.js';
import { PasswordResetMailSentEventLog } from '../../db/eventlog.js';
import { ILSUser } from '../../db/ils-user.js';

@customElement('ils-reset-password-dialog')
export class ILSResetPasswordDialog extends XDialog<Boolean> {
  static override get element_name() {
    return 'ils-reset-password-dialog';
  }

  private emailInput?: XInput;

  override render() {
    let email = '';
    return html`
      <x-flex padding="lg" space="md">
        <x-h1> Neues Passwort anfordern </x-h1>
        <x-input
          ${ref(e => (this.emailInput = e as XInput))}
          placeholder="Ihre E-Mail"
          @value-changed=${(e: ValueEvent<string>) => {
            if (e.detail.value) email = e.detail.value;
          }}
        ></x-input>
        <x-flex horizontal end space="md">
          <x-button mode="outline" @click=${() => this.close(true)}> zurück </x-button>
          <x-button
            @click=${() => {
              if (!email || !emailRegexCheck(email)) {
                const elem = this.emailInput as XInput;
                elem.error = 'Bitte geben Sie eine gültige E-Mail Adresse an.';
              } else {
                new PasswordResetMailSentEventLog({ recipient: email }).create();
                ILSUser.sendPasswordResetMail(email)();
                XSnackbar.show('Ihnen wurde eine Mail mit einem Link zum Zurücksetzen geschickt.');
                this.close(true);
              }
            }}
          >
            Neues Passwort anfordern
          </x-button>
        </x-flex>
      </x-flex>
    `;
  }
}
